import type { Action } from '@ngrx/store';
import { createAction, createReducer, on, props } from '@ngrx/store';
import type { IUserStatus } from '@rdlabo/odss-mobile-hono/src/api/auth/api';

export const defaultUserStatus = (): IUserStatus => ({
  profile: undefined,
});

export const setUserStatus = createAction('[User Status] Set', props<{ status: IUserStatus }>());

const statusReducer = createReducer(
  defaultUserStatus(),
  on(setUserStatus, (_state, { status }) => status),
);

export function reducer(state: IUserStatus | undefined, action: Action): IUserStatus {
  return statusReducer(state, action);
}
